export interface ICommissionSplittingGroup {
  name: string;
  percentage: number;
  value?: number;
}
